var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCardImage1(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 97,
    height: 87,
    viewBox: "0 0 97 87",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "_?\xEB\x8D\x89\xEC\x94\xA0??1",
    clipPath: "url(#clip0_152_1379)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M79.64 15.58C78.63 23.69 70.65 29.38 70.65 29.38C70.65 29.38 64.3 21.91 65.31 13.8C66.32 5.69 74.3 0 74.3 0C74.3 0 80.65 7.47 79.64 15.58Z",
    fill: "#16AD00"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M82.49 20.88C74.38 19.87 66.91 26.22 66.91 26.22C66.91 26.22 72.59 34.2 80.71 35.21C88.82 36.22 96.29 29.87 96.29 29.87C96.29 29.87 90.61 21.89 82.49 20.88Z",
    fill: "#16AD00"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_3",
    d: "M71.47 26.81C71.47 26.81 79.46 25.68 85.89 27.96",
    stroke: "#1FCE00",
    strokeWidth: 3,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_4",
    d: "M25.29 63.8C39.2573 63.8 50.58 52.4772 50.58 38.51C50.58 24.5427 39.2573 13.22 25.29 13.22C11.3227 13.22 0 24.5427 0 38.51C0 52.4772 11.3227 63.8 25.29 63.8Z",
    fill: "#F61D1D"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_5",
    d: "M60.29 64.67C74.2573 64.67 85.58 53.3472 85.58 39.38C85.58 25.4127 74.2573 14.09 60.29 14.09C46.3227 14.09 35 25.4127 35 39.38C35 53.3472 46.3227 64.67 60.29 64.67Z",
    fill: "#F61D1D"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_6",
    d: "M42.79 50.58C56.7573 50.58 68.08 39.2573 68.08 25.29C68.08 11.3227 56.7573 0 42.79 0C28.8227 0 17.5 11.3227 17.5 25.29C17.5 39.2573 28.8227 50.58 42.79 50.58Z",
    fill: "#F61D1D"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_7",
    d: "M27.91 86.71C41.8773 86.71 53.2 75.3873 53.2 61.42C53.2 47.4527 41.8773 36.13 27.91 36.13C13.9427 36.13 2.62 47.4527 2.62 61.42C2.62 75.3873 13.9427 86.71 27.91 86.71Z",
    fill: "#F61D1D"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_8",
    d: "M57.67 86.71C71.6373 86.71 82.96 75.3873 82.96 61.42C82.96 47.4527 71.6373 36.13 57.67 36.13C43.7027 36.13 32.38 47.4527 32.38 61.42C32.38 75.3873 43.7027 86.71 57.67 86.71Z",
    fill: "#F61D1D"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group 46"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group 45"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_9",
    d: "M63.91 47.09C64.5893 47.09 65.14 46.5393 65.14 45.86C65.14 45.1807 64.5893 44.63 63.91 44.63C63.2307 44.63 62.68 45.1807 62.68 45.86C62.68 46.5393 63.2307 47.09 63.91 47.09Z",
    fill: "#FFDA00"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_10",
    d: "M60.23 51.99C60.9093 51.99 61.46 51.4393 61.46 50.76C61.46 50.0807 60.9093 49.53 60.23 49.53C59.5507 49.53 59 50.0807 59 50.76C59 51.4393 59.5507 51.99 60.23 51.99Z",
    fill: "#FFDA00"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_11",
    d: "M67.59 51.99C68.2693 51.99 68.82 51.4393 68.82 50.76C68.82 50.0807 68.2693 49.53 67.59 49.53C66.9107 49.53 66.36 50.0807 66.36 50.76C66.36 51.4393 66.9107 51.99 67.59 51.99Z",
    fill: "#FFDA00"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group 44"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_12",
    d: "M21.91 47.09C22.5893 47.09 23.14 46.5393 23.14 45.86C23.14 45.1807 22.5893 44.63 21.91 44.63C21.2307 44.63 20.68 45.1807 20.68 45.86C20.68 46.5393 21.2307 47.09 21.91 47.09Z",
    fill: "#FFDA00"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_13",
    d: "M18.23 51.99C18.9093 51.99 19.46 51.4393 19.46 50.76C19.46 50.0807 18.9093 49.53 18.23 49.53C17.5507 49.53 17 50.0807 17 50.76C17 51.4393 17.5507 51.99 18.23 51.99Z",
    fill: "#FFDA00"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_14",
    d: "M25.59 51.99C26.2693 51.99 26.82 51.4393 26.82 50.76C26.82 50.0807 26.2693 49.53 25.59 49.53C24.9107 49.53 24.36 50.0807 24.36 50.76C24.36 51.4393 24.9107 51.99 25.59 51.99Z",
    fill: "#FFDA00"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Vector_15",
    d: "M34.04 46.2001C35.3931 46.2001 36.49 45.1031 36.49 43.75C36.49 42.397 35.3931 41.3 34.04 41.3C32.6869 41.3 31.59 42.397 31.59 43.75C31.59 45.1031 32.6869 46.2001 34.04 46.2001Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_16",
    d: "M51.2 46.2001C52.5531 46.2001 53.65 45.1031 53.65 43.75C53.65 42.397 52.5531 41.3 51.2 41.3C49.8469 41.3 48.75 42.397 48.75 43.75C48.75 45.1031 49.8469 46.2001 51.2 46.2001Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_17",
    d: "M42.77 53.2C39.93 53.2 37.92 50.04 37.84 49.91L39.23 49.04C39.67 49.74 41.17 51.56 42.78 51.56C43.88 51.56 44.97 50.71 46.02 49.04L47.41 49.91C46.05 52.09 44.49 53.2 42.78 53.2H42.77Z",
    fill: "black"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_152_1379"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 96.29,
    height: 86.71,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCardImage1);
export default __webpack_public_path__ + "static/media/cardImage1.a4fd686dd49505c292c59d808528fc53.svg";
export { ForwardRef as ReactComponent };